import { render, staticRenderFns } from "./Exemplo3.vue?vue&type=template&id=24128eb8&"
import script from "./Exemplo3.vue?vue&type=script&lang=js&"
export * from "./Exemplo3.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports